import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { Grid, TextField } from '@material-ui/core'
import { conditionTypes, TriggerTypes } from 'consts/automatedActionConsts'
import { useSelector } from 'react-redux'
import { Autocomplete } from '@material-ui/lab'
import { StatusTypes } from '@grin-rnd/grin-api-sdk/dist/Enums/Statuses'
import ErrorMessage from 'components/common/text/ErrorMessage'

const PatientStatus = ({ onChange = () => {}, params = {}, isSystem, selectedTriggerType, errors }) => {
  const { t } = useTranslation()

  const statuses = useSelector(state => state.treatmentReducer.statuses.types)
  const errorMessage = useMemo(() => errors.conditions?.[conditionTypes.PatientStatus], [errors])

  const defaultAllowedStatuses = useMemo(
    () => [StatusTypes.ActiveTreatment, StatusTypes.Retention, StatusTypes.Observation, StatusTypes.NewLead],
    []
  )

  const allowedStatusesByTriggerType = useMemo(
    () => ({
      [TriggerTypes.LeadCreated]: [StatusTypes.Invited, StatusTypes.RecordsOnly]
    }),
    []
  )

  const options = useMemo(
    () =>
      statuses
        .filter(status =>
          isSystem
            ? true
            : allowedStatusesByTriggerType[selectedTriggerType]
            ? allowedStatusesByTriggerType[selectedTriggerType].includes(status)
            : defaultAllowedStatuses.includes(status)
        )
        .map(statusKey => ({ value: statusKey, label: t(`statuses.names.${statusKey}`) })),
    [isSystem, statuses, defaultAllowedStatuses, allowedStatusesByTriggerType, selectedTriggerType, t]
  )

  return (
    <Grid container direction="column">
      <Grid item>
        <Autocomplete
          id="patient-statuses-selector"
          multiple
          fullWidth
          filterSelectedOptions
          style={{ minWidth: 300 }}
          options={options}
          value={params?.statuses || []}
          getOptionLabel={option => option.label}
          renderInput={params => (
            <TextField
              {...params}
              variant="standard"
              label={t('pages.accountSettings.automations.editorModal.patientStatus')}
            />
          )}
          onChange={(event, updatedSelectedStatuses, reason) => {
            onChange({ type: conditionTypes.PatientStatus, params: { statuses: updatedSelectedStatuses } })
          }}
        />
      </Grid>
      <Grid item>
        <ErrorMessage active={errorMessage} text={errorMessage} />
      </Grid>
    </Grid>
  )
}

export default PatientStatus
